import { Node_Type } from 'ricos-types';
import { TOOLBARS, INSERT_PLUGIN_BUTTONS, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { gifModals, DEFAULTS } from './constants.js';
import GiphyInsertModal from './modals/InsertModal.js';
import InsertPluginIcon from './icons/InsertPluginIcon.js';
import 'wix-rich-content-common';
import 'react';
import 'ricos-content/libs/convertBlockDataToRicos';
import 'ricos-context';
import './giphyApiInputModal-231cb95c.js';
import 'classnames';
import 'lodash';
import 'wix-rich-content-ui-components';
import './style-inject.es-e7b07dd7.js';
import './dataHooks.js';
import './toolbar/giphySelector.js';
import 'react-custom-scrollbars';
import 'react-infinite-scroller';
import './giphyEmptyState-bcf7b38a.js';
import './toolbar/getGiphyProxyUrl.js';
import './icons/PoweredByGiphy.js';
import './types.js';

const toolbarsToAddIn = [
  TOOLBARS.MOBILE,
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE
];
const getAddButtons = (config, services) => {
  return [
    {
      id: Node_Type.GIF,
      label: INSERT_PLUGIN_BUTTONS.GIF,
      dataHook: INSERT_PLUGIN_BUTTONS.GIF,
      icon: InsertPluginIcon,
      tooltip: "GiphyPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: () => true,
      modal: {
        id: gifModals.insert,
        Component: decorateComponentWithProps(GiphyInsertModal, {
          componentData: DEFAULTS,
          modalId: gifModals.insert,
          getGiphyUrl: config == null ? void 0 : config.getGiphyUrl
        })
      },
      menuConfig: {
        tags: "Gif_plugin_search_tags"
      }
    }
  ];
};

export { getAddButtons, toolbarsToAddIn };
//# sourceMappingURL=getAddButtons.js.map
